<button
  (click)="onClick()"
  [class.active]="active"
  [class.is-hovered]="isHovered"
  [class.loading-mode]="isLoading"
  [class.medium]="size === 'medium'"
  [class.small]="size === 'small'"
  [disabled]="disabled"
  class="{{type}} {{color}}">
  @if (isLoading) {
    <div class="loading">
      <div class="spinner"></div>
    </div>
  } @else {
    @if (tooltipText) {
      <i
        [actions]="actions"
        [positionTooltip]="positionTooltip"
        [textAlign]="textAlign"
        appAwesomeTooltipV2
        class="{{icon}}"
        tooltipText="{{ tooltipText }}"
      ></i>
    } @else {
      <i class="{{icon}}"></i>
    }
  }
</button>
